export default __webpack_public_path__ + "media/images/images/gallery/15-289a9a63379d9afd8c9dac044700623b.jpg";